module.exports = __webpack_public_path__ + "static/ProposalBuilder-b2fae5d2c8ed8d7fa7b49ff91bc326f3.jpg";